import { render } from "./BasicSelectBox.vue?vue&type=template&id=7d58fb8d"
import script from "./BasicSelectBox.vue?vue&type=script&lang=js"
export * from "./BasicSelectBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__